import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import TableHead from './TableHead';

class TablePolynomyHeads extends PureComponent {
  render() {
    const { tableHeads } = this.props;
    const tableHeadList = tableHeads.map(
      tableHead => <TableHead key={tableHead.id} tableHead={tableHead} />,
    );
    return (
      <thead>
        <tr>
          { tableHeadList }          
        </tr>
      </thead>
    );
  }
}

// props validation
TablePolynomyHeads.propTypes = {
  tableHeads: PropTypes.arrayOf(PropTypes.array),
};

TablePolynomyHeads.defaultProps = {
  tableHeads: [{
    id: '1',
    name: 'N°',
    class: 'w-5',
    prop: 'id'
  }, {
    id: '2',
    name: 'Código',
    class: 'w-95',
    prop: 'code'
  }],
};

export default TablePolynomyHeads;